import React, { useEffect } from "react";
import DeudoresXPremioStep1 from '../../Resources/Images/Tutoriales/DeudoresXPremio/DeudoresXPremio-1.jpg';
import DeudoresXPremioStep2 from '../../Resources/Images/Tutoriales/DeudoresXPremio/DeudoresXPremio-2.jpg';
import StepTutorial from './index-step';

function getSteps() {
    return ['Paso 1', 'Paso 2'];
}

function getStepContent(stepIndex) {
    switch (stepIndex) {
        case 0:
            return <StepTutorial image={DeudoresXPremioStep1} text={[
                'Seleccionar productor',
                'Seleccionar fecha de consulta',
                'Hacer click en el botón “Buscar” para generar el listado'
            ]} />;
        case 1:
            return <StepTutorial image={DeudoresXPremioStep2} text={[
                'Al hacer click en el botón “Descargar” podrás exportar el listado a Excel'
            ]} />;
        default:
            return '¡Tutorial completado!';
    }
}

export function Deudores({ activeStep, setSteps }) {
    const steps = getSteps();

    useEffect(() => {
        setSteps(steps);
    }, [setSteps, steps]);

    return (
        <>
            <h2>Paso a paso para utilizar la búsqueda de Rechazos</h2>
            <div className="d-flex justify-content-center mb-4">
                {steps.map((label, index) => (
                    <div
                        key={label}
                        className={`text-center mx-2 px-3 py-2 rounded ${index === activeStep ? 'bg-primary text-white' : 'bg-light text-secondary'}`}
                        style={{ minWidth: 80 }}
                    >
                        <div className="fw-bold">{label}</div>
                        <div className="small">Paso {index + 1}</div>
                    </div>
                ))}
            </div>

            <div>
                {getStepContent(activeStep)}
            </div>
        </>
    );
}
